import { PolicyType } from './policy-types.model';

export class PermissionValidator {
  policies: PolicyType[];
  validateAll: boolean;

  constructor(policies: PolicyType[], validateAll: boolean = false) {
    this.policies = policies;
    this.validateAll = validateAll;
  }
}
